import MonthlySchedule from './MonthlySchedule'

export default {
	name: 'MamanScheduleApp',
	data () {
		return {
		}
	},
	components: {
		MonthlySchedule
	},
	mounted: function () {
		// DOM を描画した直後に呼ばれる
		var me = this;

		[].forEach.call(me.$el.querySelectorAll('.js-loading'), function (el) {
			el.parentNode.removeChild(el)
		})
	}
}
